<template>
    <v-container>
        <v-layout row justify-center>
            <v-flex v-for="text in texts" :key="text.id">
                <v-layout v-bind:class="{'pt-5':(screen.x < 950 && screen.x >= 450), 'pt-2':(screen.x >= 950 || screen.x < 450)}">
                    <v-flex class="title-text" v-bind:class="{'center':screen.x < 950}">{{text.header}}</v-flex>
                </v-layout>
                <v-layout>
                    <v-flex>
                        <v-card-text v-for="data in text.datas" style="padding: 8px" :key="data.id" class="details" v-bind:class="{'large-text':(screen.x > 950), 'small-text':(screen.x < 950 && screen.x >= 450), 'mobile-text':(screen.x < 450), 'center':(screen.x < 950)}">
                            {{data.string}}
                        </v-card-text>
                    </v-flex>
                </v-layout>
                <v-layout>
                    <v-flex class="justify-center">
                        <div class="text-xs-center">
                            <v-btn v-if="text.header === 'Hubungi Kami'" :href="`${text.whatsapp}`" target="_blank">
                            <a>Hubungi Via Whatsapp</a>
                            </v-btn>
                        </div>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
export default {
    props: {
        texts : Array,
        screen : Object
    }
}
</script>




// WEBPACK FOOTER //
// src/components/SplitText.vue